import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { installAuth } from './auth/index.js'
import { i18n } from './i18n/index.js'
import { router } from './router.js'
import './style.css'

const app = createApp(App)
app.use(createPinia())
app.use(i18n)

// Auth is installed before the router so a guard can never observe an
// unresolved session and bounce an already-authenticated user to the login
// screen on a hard refresh.
//
// This ordering runs inside a function, NOT as a top-level `await`. `session.ts`
// reaches MSAL through `import('./msal.js')`, and Rollup gives that chunk a
// static import back to this entry chunk. A top-level await here parks the entry
// module mid-evaluation, the msal chunk then waits for the entry module to
// finish, and the two deadlock: no error, no mount, a blank page. It only
// appears in a built bundle - the dev server serves unbundled modules and has no
// such cycle. Returning from this module immediately lets the cycle resolve.
void (async () => {
  await installAuth(app)

  app.use(router)
  app.mount('#app')
})()
